
import { useNavigate } from "react-router-dom";
import "./PanelConductor.css";

export default function PanelConductor() {
  const navigate = useNavigate();

  const usuario = JSON.parse(
    sessionStorage.getItem("usuario") || "null"
  );

  const cerrarSesion = () => {
    sessionStorage.removeItem("usuario");
    sessionStorage.removeItem("token");
    navigate("/");
  };

  return (
    <div className="panel-conductor">

      {/* Encabezado */}
      <div className="panel-conductor-header">
        <div>
          <h1 className="panel-conductor-titulo">
            Panel del Conductor
          </h1>

          <p className="panel-conductor-subtitulo">
            Sistema de gestión de viáticos | Transportes Figueroa
          </p>
        </div>

        <button
          type="button"
          className="panel-conductor-salir"
          onClick={cerrarSesion}
        >
          Cerrar sesión
        </button>
      </div>

      {/* Bienvenida */}
      <div className="panel-conductor-bienvenida">
        <h2>
          Bienvenido, {usuario?.nombre || "Conductor"}
        </h2>

        <p>
          Desde este panel puedes gestionar tus solicitudes
          de viáticos y consultar el estado de tus viajes.
        </p>

        <span className="panel-conductor-id">
          ID de conductor: {usuario?.id_conductor ?? "No disponible"}
        </span>
      </div>

      {/* Opciones principales */}
      <h2 className="panel-conductor-seccion">
        ¿Qué deseas realizar?
      </h2>

      <div className="panel-conductor-opciones">

        {/* Solicitar viáticos */}
        <button
          type="button"
          className="panel-conductor-tarjeta"
          onClick={() => navigate("/solicitar-viatico")}
        >
          <div className="panel-conductor-icono">
            +
          </div>

          <h3>Solicitar viáticos</h3>

          <p>
            Registra una nueva solicitud de viáticos
            para tu próximo viaje y consulta el monto
            calculado según la ruta.
          </p>
        </button>

        {/* Mis solicitudes */}
        <button
          type="button"
          className="panel-conductor-tarjeta"
          onClick={() => navigate("/mis-solicitudes")}
        >
          <div className="panel-conductor-icono">
            ☷
          </div>

          <h3>Mis solicitudes</h3>

          <p>
            Consulta tus solicitudes, revisa su estado
            y registra la liquidación de los viáticos
            recibidos cuando corresponda.
          </p>
        </button>

      </div>
    </div>
  );
}
